import {Configs} from '#bunker/types';
import LoggerWithEvents from '@yandex-int/error-counter/dist/loggerWithEvents';
import {LogErrorOptions, LogEventParams} from './types';

class ErrorCounterLogger {
    private _logger: LoggerWithEvents | null = null;

    initLogger({env, version, login, configs}: Ya.Rum.LogErrorInitSettings & {login?: string, configs?: Configs}) {
        if (typeof window === 'undefined' || !window.document) {
            return;
        }

        const logger = new LoggerWithEvents();

        logger.initErrors({
            reqid: `${Date.now()}.${Math.random()}`,
            project: 'callform-frontend',
            env,
            version,
            additional: {
                login,
                version,
                configs,
            },
            debug: env === 'development',
        });

        this._logger = logger;
    }

    _sendLog(params: Ya.Rum.LogErrorOptions, error: Error) {
        !this._logger?.getErrorSetting('debug') && this._logger?.logError(params, error);
    }

    info(params: LogErrorOptions, error: Error) {
        !this._logger?.getErrorSetting('debug') && this._sendLog({level: 'info', ...params}, error);
    }

    warn(params: LogErrorOptions, error: Error) {
        !this._logger?.getErrorSetting('debug') && this._sendLog({level: 'warn', ...params}, error);
    }

    error(params: LogErrorOptions, error: Error) {
        !this._logger?.getErrorSetting('debug') && this._sendLog({level: 'error', ...params}, error);
    }

    logEventString(name: string, {value = '', options}: LogEventParams<string> = {}) {
        !this._logger?.getErrorSetting('debug') && this._logger?.logEventString(name, value, options);
    }

    updateAdditional(additional: Ya.Rum.Additional) {
        if (additional) {
            this._logger?.updateAdditional(additional);
        }
    }
}

export const logger = new ErrorCounterLogger();
